module.exports = __webpack_public_path__ + "img/iqiyi.632a681f.png";